import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'
import PropTypes from 'prop-types'

const styles = theme => ({})

// First try to find in the material-ui core icons here: https://material.io/tools/icons/?style=baseline
// Second try to get it from here which are compatable with code below: https://materialdesignicons.com/
// If you can't find it at materialdesignicons.com, try to convert it.
//  Resize to 24x24: https://www.iloveimg.com/resize-image/resize-svg (inkscape didn't work)
//  Optimise path here: http://petercollingridge.appspot.com/svg-optimiser
function IconTable (props) {
  const { classes, htmlColor, iconSizeEnum } = props
  return (
    <div className={classes.root}>
      <SvgIcon className={classes.icon} htmlColor={htmlColor} fontSize={iconSizeEnum}>
        <path d="M4,3H20A2,2 0 0,1 22,5V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V5A2,2 0 0,1 4,3M4,7V10H8V7H4M10,7V10H14V7H10M20,10V7H16V10H20M4,12V15H8V12H4M4,20H8V17H4V20M10,12V15H14V12H10M10,20H14V17H10V20M20,20V17H16V20H20M20,12H16V15H20V12Z" />
      </SvgIcon>
    </div>
  )
}

IconTable.propTypes = {
  classes: PropTypes.object.isRequired,
  htmlColor: PropTypes.string,
  iconSizeEnum: PropTypes.string
}

export default withStyles(styles)(IconTable)
